/**
 * When the current user clicks Leave, we navigate immediately.
 * Socket echo (videoSessionDisconnectResponse) must NOT trigger a second
 * hard reload (window.location) or the hang-up feels slow.
 */
let selfLeavingUntil = 0;
let lastLeftAppointmentId = null;

export function markSelfLeaving(appointmentId = null) {
  selfLeavingUntil = Date.now() + 8000;
  lastLeftAppointmentId = appointmentId ? String(appointmentId) : null;
}

export function isSelfLeaving(appointmentId = null) {
  if (Date.now() > selfLeavingUntil) return false;
  if (appointmentId && lastLeftAppointmentId && String(appointmentId) !== lastLeftAppointmentId) {
    return false;
  }
  return true;
}

export function clearSelfLeaving() {
  selfLeavingUntil = 0;
  lastLeftAppointmentId = null;
}
